import { createSelector } from 'reselect';

import { AngelInvestorMembersStateType } from '../../../types/reduxTypes/StateTypes';
import { StateType } from '../../../types';

const selectMembersState = (state: StateType) => state.angelInvestorMembersReducer;

export const selectEventFilterType = createSelector(
  selectMembersState,
  (state: AngelInvestorMembersStateType) => state.selectedMember.eventFilter,
);

export const selectMemberDetails = createSelector(
  selectMembersState,
  (state: AngelInvestorMembersStateType) => state.selectedMember.data,
);

export const selectPastEvents = createSelector(
  selectMembersState,
  (state: AngelInvestorMembersStateType) => state.selectedMember.pastEvents,
);

export const selectUpcomingEvents = createSelector(
  selectMembersState,
  (state: AngelInvestorMembersStateType) => state.selectedMember.upcomingEvents,
);
